export const Routes = {
  isVatMember: () => "/is-vat-member",
  innovationLabSendConfirmationEmail: () =>
    "/send-innovation-lab-confirmation-email",
  mailchimpCreateCartPath: () => "/create-mailchimp-cart",
  mailchimpDeleteCartPath: () => "/delete-mailchimp-cart",
  automationMailchimpCreateStorePath: () =>
    "/automation-create-mailchimp-store",
  automationMailchimpDeleteStorePath: () =>
    "/automation-delete-mailchimp-store",
  automationMailchimpCreateProductPath: () =>
    "/automation-create-mailchimp-product",
}
